import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanDeactivate}  from '@angular/router';
import { NoteEntryComponent} from '../note-entry/note-entry.component';
import { AppEntryComponent} from '../app-entry/app-entry.component';

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard implements CanDeactivate<NoteEntryComponent>, CanDeactivate<AppEntryComponent> {
  canDeactivate(component: NoteEntryComponent | AppEntryComponent): Observable<boolean> | boolean {
    return component.isOKForReset();
  }
}
